import {
  WIZARD_SET_PAGE_COUNT,
  WIZARD_PAGE_NEXT,
  WIZARD_PAGE_SKIP,
  WIZARD_PAGE_PREV,
  WIZARD_DONE,
  WIZARD_RESET,
  WIZARD_SET_DEVICE,
  WIZARD_ERROR,
  WIZARD_ALERT,
} from '../constants/actionTypes';

const initialState = {
  page: 1,
  pageCount: 0,
  done: false,
  doneMessage: null,
  deviceId: null,
  error: null,
  alert: null,
  history: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case WIZARD_SET_PAGE_COUNT:
      return {
        ...state,
        pageCount: action.count,
      };
    case WIZARD_SET_DEVICE:
      return {
        ...state,
        deviceId: action.deviceId,
      };
    case WIZARD_PAGE_NEXT:
      return {
        ...state,
        page: state.page < state.pageCount ? state.page + 1 : state.pageCount,
        history: [state.page, ...state.history],
      };
    case WIZARD_PAGE_SKIP: // Do not update last page
      return {
        ...state,
        page: state.page < state.pageCount ? state.page + 1 : state.pageCount,
      };
    case WIZARD_PAGE_PREV:
      const [previous, ...other] = state.history;
      return {
        ...state,
        page: previous || 1,
        history: other,
      };
    case WIZARD_DONE:
      return {
        ...state,
        done: true,
        doneMessage: action.message,
      };
    case WIZARD_ERROR:
      return {
        ...state,
        error: action.error,
        showDeviceInput: action.showDeviceInput,
      };
    case WIZARD_ALERT:
      return {
        ...state,
        alert: action.alert,
      };
    case WIZARD_RESET:
      return initialState;
    default:
      return state;
  }
};
